import { Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'mpro-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss', './../login-common.scss'],
})
export class ResetPasswordComponent implements OnInit, OnDestroy {
  public passwordControl: UntypedFormControl = new UntypedFormControl();
  private email: string;
  private emailSecret: string;
  private ngUnsubscribe: Subject<void> = new Subject();

  constructor(private authService: AuthService, private router: Router) {
    if (this.authService.isLoggedIn()) {
      this.router.navigate(['/']);
    }
  }

  public ngOnInit(): void {
    const params = this.router.routerState.root.snapshot.queryParams;
    this.email = params['email'];
    this.emailSecret = params['emailSecret'];
    if (!this.emailSecret) {
      this.router.navigate(['/']);
    }
  }

  public ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  public resetPassword(): void {
    if (!this.passwordControl.valid) {
      return;
    }

    this.authService
      .resetPassword(
        this.email,
        this.emailSecret,
        this.passwordControl.value.password
      )
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(() => this.router.navigate(['/']));
  }
}
